import { MapPin } from "lucide-react";
import { SectionCard, Segmented, InfoNote } from "@/components/common/Cards";
import { Field, MoneyInput, NumInput, TextInput } from "@/components/common/Inputs";
import { Textarea } from "@/components/ui/textarea";

export default function RegionPanel({ data, setData, readOnly }) {
  const r = data.region;
  const setR = (patch) => setData((d) => ({ ...d, region: { ...d.region, ...patch } }));
  return (
    <div className="grid lg:grid-cols-[1fr_1fr] gap-5">
      <SectionCard title="Identitas Wilayah" eyebrow="Wilayah ISP" testid="isp-region-card">
        <div className="space-y-4">
          <Field label="Status wilayah">
            <Segmented
              value={r.status}
              onChange={(v) => setR({ status: v })}
              testid="isp-region-status"
              size="sm"
              options={[
                { value: "new", label: "Wilayah baru (perencanaan)" },
                { value: "existing", label: "Wilayah existing (sudah beroperasi)" },
              ]}
              disabled={readOnly}
            />
          </Field>
          <Field label="Nama wilayah">
            <TextInput value={r.name} onChange={(v) => setR({ name: v })} testid="isp-region-name" disabled={readOnly} />
          </Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Kota">
              <TextInput value={r.city} onChange={(v) => setR({ city: v })} testid="isp-region-city" disabled={readOnly} />
            </Field>
            <Field label="Provinsi">
              <TextInput value={r.province} onChange={(v) => setR({ province: v })} testid="isp-region-province" disabled={readOnly} />
            </Field>
          </div>
          <Field label="Homes passed (jumlah rumah terjangkau)" hint="Pakai perkiraan rumah/kavling yang jaringan FTTH-nya menjangkau area ini.">
            <NumInput value={r.homesPassed} onChange={(v) => setR({ homesPassed: v })} decimals={0} suffix="KK" testid="isp-region-homes" disabled={readOnly} />
          </Field>
          <Field label="Catatan">
            <Textarea value={r.notes} onChange={(e) => setR({ notes: e.target.value })} className="bg-[hsl(220_12%_8%)] border-border text-sm min-h-[80px]" data-testid="isp-region-notes" disabled={readOnly} />
          </Field>
        </div>
      </SectionCard>
      <SectionCard title="Proyeksi akuisisi" eyebrow="Projection" testid="isp-projection-card">
        <div className="space-y-4">
          <Field label="Target total pelanggan" hint="Target akhir setelah periode ramp-up.">
            <NumInput value={data.projection.targetSubscribers} onChange={(v) => setData((d) => ({ ...d, projection: { ...d.projection, targetSubscribers: v } }))} decimals={0} suffix="subs" testid="isp-proj-target" disabled={readOnly} />
          </Field>
          <Field label="Durasi ramp-up" hint="Berapa bulan dari 0 pelanggan sampai target tercapai.">
            <NumInput value={data.projection.rampMonths} onChange={(v) => setData((d) => ({ ...d, projection: { ...d.projection, rampMonths: v } }))} decimals={0} suffix="bln" testid="isp-proj-ramp" disabled={readOnly} />
          </Field>
          <Field label="Horizon proyeksi">
            <NumInput value={data.projection.horizonMonths} onChange={(v) => setData((d) => ({ ...d, projection: { ...d.projection, horizonMonths: v } }))} decimals={0} suffix="bln" testid="isp-proj-horizon" disabled={readOnly} />
          </Field>
          <Field label="Churn pelanggan / bulan">
            <NumInput value={data.projection.churnPct} onChange={(v) => setData((d) => ({ ...d, projection: { ...d.projection, churnPct: v } }))} suffix="%" decimals={1} testid="isp-proj-churn" disabled={readOnly} />
          </Field>
          <InfoNote>
            Untuk wilayah <b>existing</b>, jumlah pelanggan setiap paket diatur manual di tab Paket. Untuk wilayah <b>baru</b>, mix paket & target pelanggan di sini digunakan.
          </InfoNote>
        </div>
      </SectionCard>
    </div>
  );
}
